import { render } from "./PaymentBankAccount.vue?vue&type=template&id=03c2205c&scoped=true&ts=true"
import script from "./PaymentBankAccount.vue?vue&type=script&lang=ts"
export * from "./PaymentBankAccount.vue?vue&type=script&lang=ts"

import "./PaymentBankAccount.vue?vue&type=style&index=0&id=03c2205c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c2205c"]])

export default __exports__